import { cardPreviews } from "./card-preview";
import { recordPageHit } from "./page-hits";

recordPageHit(document.referrer);

const letters = document.querySelector<HTMLElement>(".letters[data-set]");
if (letters) cardPreviews(letters);
